import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue"

import { useModalsStore } from '@/stores/modals';
import { transition } from '@/helpers/animation'
import ModalProvider from './ModalProvider.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalController',
  setup(__props) {

const modalsStore = useModalsStore();

function onModalEnter(elem: HTMLElement, done: () => void) {
  if (elem.dataset.immediateOpen === 'true'){
    done();
    return;
  }

  const modalWrapper = elem.querySelector('.modal-wrapper') as HTMLElement|undefined;
  transition({
    duration: 300,
    callback(value: number) {
      elem.style.opacity = String(value);
      if (modalWrapper){
        modalWrapper.style.transform = `translateY(${-50 + (50 * value)}px)`;
      }
    },
  }).p.then(() => {
    elem.style.opacity = '';
    if (modalWrapper){
      modalWrapper.style.transform = '';
    }
    done();
  });
}
function onModalLeave(elem: HTMLElement, done: () => void) {
  if (elem.dataset.immediateClose === 'true'){
    done();
    return;
  }

  const modalWrapper = elem.querySelector('.modal-wrapper') as HTMLElement|undefined;
  transition({
    duration: 200,
    callback(value: number) {
      elem.style.opacity = String(1 - value);
      if (modalWrapper){
        modalWrapper.style.transform = `translateY(${50 * value}px)`;
      }
    },
  }).p.then(() => {
    done();
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_TransitionGroup, {
      name: "fade-modal",
      css: false,
      onEnter: onModalEnter,
      onLeave: onModalLeave
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(modalsStore).state.modals, (modal) => {
          return (_openBlock(), _createBlock(ModalProvider, {
            key: modal.id,
            data: modal,
            "data-immediate-open": modal.immediateOpen,
            "data-immediate-close": modal.immediateClose
          }, null, 8, ["data", "data-immediate-open", "data-immediate-close"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})